/**
 * Represents the type of the format of many to one relationship field in the record
 */
export const enum ManyToOneRelationshipFieldFormatType {
  /** No return. */
  None = 'none',

  /** Returns the id and a default field of the related records. */
  SelectOptions = 'select_options',

  /** Returns the full record. */
  Full = 'full',
}

/**
 * Represents the type of the format of one to many relationship field in the record
 */
export const enum OneToManyRelationshipFieldFormatType {
  /** Return the count of related records in case of 1-N relationship. */
  Count = 'count',

  /** No return. */
  None = 'none',

  /** Returns the id and a default field of the related records. */
  SelectOptions = 'select_options',

  /** Returns the full record. */
  Full = 'full',
}

/**
 * Represents the type of format count
 */
export const enum CountFormatType {
  /** Returns only the total number of records in the table. */
  All = 'all',

  /** Returns only the total number of records in the query when paginate is false. */
  Query = 'query',

  /** Returns the total number of records in the table and in the query. */
  Both = 'both',
}

/**
 * Represents the type of the record
 */
export type ClickRecord = {
  /** The Id of the record */
  id: string;

  /** The createdAt of the record */
  createdAt: string;

  /** The updateAt of the record */
  updatedAt: string;

  /** The data of custom field in the record */
  [key: string]: any;
};

/**
 * Represents the sort direction
 */
export const enum SortDirection {
  /** Sort up ascending */
  Ascend = -1,

  /** Sort up descending */
  Descend = 1,
}
